import type React from 'react';
import Glider from 'react-glider';
import Modal from 'react-modal';
import { ArrowIosLeft, ArrowIosRight, Close } from '@shared/assets';
import { IconButton } from '@shared/ui';
import 'glider-js/glider.min.css';
import * as st from './styles.module.scss';

Modal.setAppElement('#root');

interface Props extends Modal.Props {
  images: string[];
  scrollTo: number;
  productTitle: string;
}

export const LargeCarouselModal: React.FC<Props> = ({
  images,
  scrollTo,
  productTitle,
  ...props
}) => {
  return (
    <Modal className={st.modal} overlayClassName={st.overlay} {...props}>
      {images.length > 1 && (
        <IconButton
          variant="dark"
          id="buttonPrevModal"
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => e.stopPropagation()}
        >
          <ArrowIosLeft />
        </IconButton>
      )}

      <div className={st.wrapper}>
        <button className={st.close} onClick={props.onRequestClose}>
          <Close />
        </button>
        <Glider
          hasArrows
          rewind
          slidesToShow={1}
          slidesToScroll={1}
          arrows={{ prev: '#buttonPrevModal', next: '#buttonNextModal' }}
          scrollToSlide={scrollTo}
          className={st.glider}
          itemWidth={256}
          responsive={[
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                itemWidth: 1180,
              },
            },
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                itemWidth: 640,
              },
            },
          ]}
        >
          {images.map((img) => (
            <div key={img} className={st.slide__wrapper}>
              <img className={st.slide__image} src={img} alt={productTitle} />
            </div>
          ))}
        </Glider>
      </div>
      {images.length > 1 && (
        <IconButton
          variant="dark"
          id="buttonNextModal"
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => e.stopPropagation()}
        >
          <ArrowIosRight />
        </IconButton>
      )}
    </Modal>
  );
};
